import { Tooltip } from '~/components/Tooltip/Tooltip';
import { HelpIcon } from '~/components/Icon/HelpIcon';
import styles from './Label.module.css';

interface Props {
  htmlFor: string | number | symbol;
  label?: string;
  tooltip?: string;
}

export function Label({ htmlFor, label, tooltip }: Props) {
  if (!label) {
    return false;
  }

  return (
    <label htmlFor={htmlFor as string} className={styles.label}>
      {label}

      {tooltip && (
        <Tooltip title={tooltip} className={styles.help} as="span">
          <HelpIcon />
        </Tooltip>
      )}
    </label>
  );
}
